import { Component, OnInit } from '@angular/core';
import { ProdutoService } from '../../produto/produto.service';
import { EventoProdutoImportacaoLog } from '../models/evento';

@Component({
  selector: 'app-evento-produto-importar-log',
  templateUrl: './evento-produto-importar-log.component.html',
  styleUrls: ['./evento-produto-importar-log.component.scss']
})
export class EventoProdutoImportarLogComponent implements OnInit {

  public listaLog: EventoProdutoImportacaoLog[];
  
  constructor(public produtoService: ProdutoService) { }

  ngOnInit(): void {
    console.log("entrou");
    this.getLog();    
  }


  getLog() {
    this.produtoService.getLogImportacaoProduto().subscribe(
      (res) => {
        if (res) {
          this.listaLog = res; 
               console.log(this.listaLog);
        }
      },
      err => {
        console.log("EventoProdutoImportarLog - Logs");
        console.log(err);
      }
    );
  } 

}
